/* eslint-disable */
'use client';

import * as React from 'react';
import { Button as CoreButton, cn } from '@newfront-insurance/core-ui/v2';

type ArtifactPreviewButtonVariant = 'default' | 'ghost' | 'outline' | 'secondary';
type ArtifactPreviewButtonSize = 'default' | 'icon-sm' | 'sm';

export interface ArtifactPreviewButtonProps extends Omit<React.ComponentProps<typeof CoreButton>, 'size' | 'variant'> {
  size?: ArtifactPreviewButtonSize;
  variant?: ArtifactPreviewButtonVariant;
}

const variantClassNames: Record<ArtifactPreviewButtonVariant, string> = {
  default: '',
  ghost:
    'border-transparent bg-transparent text-[#546a83] shadow-none hover:border-transparent hover:bg-[#f4f8fe] hover:text-[#262d46] active:bg-[#eaf1f9]',
  outline:
    'border-[#d8e0ea] bg-white text-[#546a83] shadow-none hover:border-[#c7d3e2] hover:bg-[#f4f8fe] hover:text-[#262d46] active:bg-[#eaf1f9]',
  secondary:
    'border-transparent bg-[#eef4fb] text-[#546a83] shadow-none hover:bg-[#e4edf8] hover:text-[#262d46] active:bg-[#d8e6f5]',
};

const sizeClassNames: Record<ArtifactPreviewButtonSize, string> = {
  default: '',
  'icon-sm': 'size-7 min-w-7 px-0 py-0',
  sm: 'h-8 px-2 py-0 text-sm',
};

export const Button = React.forwardRef<HTMLButtonElement, ArtifactPreviewButtonProps>(
  ({ className, size = 'default', variant = 'default', ...props }, ref) => {
    const coreVariant = variant === 'default' ? 'primary' : variant === 'outline' ? 'secondary' : 'transparent';
    const coreSize = size === 'default' ? 'default' : 'small';

    return (
      <CoreButton
        ref={ref}
        size={coreSize}
        variant={coreVariant}
        className={cn(sizeClassNames[size], variantClassNames[variant], className)}
        {...props}
      />
    );
  },
);

Button.displayName = 'ArtifactPreviewButton';
